import { render, staticRenderFns } from "./activity-6.vue?vue&type=template&id=3687ab30&"
import script from "./activity-6.vue?vue&type=script&lang=js&"
export * from "./activity-6.vue?vue&type=script&lang=js&"
import style0 from "./activity-6.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports